export const SSO_PROVIDERS_LIST = [
  {
    name: "AWS",
    url: "/assets/companies/aws.png",
  },
  {
    name: "Microsoft Entra ID",
    url: "/assets/companies/microsoft_intra_id.png",
  },
  {
    name: "Okta",
    url: "/assets/companies/okta.png",
  },
  {
    name: "Google Workspace",
    url: "/assets/companies/google3.png",
  },
  {
    name: "Microsoft Active Directory",
    url: "/assets/companies/active_directory.png",
  },
  {
    name: "Auth0",
    url: "/assets/companies/auth0.png",
  },
  {
    name: "CyberArk",
    url: "/assets/companies/cyberark2.png",
  },
  {
    name: "JumpCloud",
    url: "/assets/companies/jumpcloud2.png",
  },
  {
    name: "OneLogin",
    url: "/assets/companies/oneLogin.png",
  },
  {
    name: "Oracle Cloud Infrastructure",
    url: "/assets/companies/oracle.png",
  },
  {
    name: "PingOne",
    url: "/assets/companies/pingOne.png",
  },
  { name: "Duo", url: "/assets/companies/duo.png" },
  {
    name: "Salesforce",
    url: "/assets/companies/salesforce.png",
  },
  {
    name: "LastPass",
    url: "/assets/companies/lastpass.png",
  },
  {
    name: "Cloudflare",
    url: "/assets/companies/cloudflare.png",
  },
];

export const SSO_GENERIC_PROTOCOLS_LIST = [
  {
    name: "Saml",
    url: "/assets/companies/saml.png",
  },
  {
    name: "OpenId",
    url: "/assets/companies/openid.png",
  },
];

export const disabledButtonReason = "You don’t have permission to perform this action."

export const sharedColumnDisplayOrder = [
  { id: "name", label: "Name", visible: true, alwaysVisible: true },
  { id: "region", label: "Region", visible: true, alwaysVisible: true },
  { id: "state", label: "State", visible: true, alwaysVisible: true },
  { id: "users", label: "Users", visible: true, alwaysVisible: false },
  { id: "sessions", label: "Sessions", visible: false, alwaysVisible: false },
  { id: "idps", label: "IdPs", visible: false, alwaysVisible: false },
  { id: "healthy", label: "Healthy", visible: true, alwaysVisible: false },
  { id: "actions", label: "Actions", visible: true, alwaysVisible: true },
];

export const dedicatedColumnDisplayOrder = [
  { id: "name", label: "Name", visible: true, alwaysVisible: true },
  { id: "region", label: "Region", visible: true, alwaysVisible: true },
  { id: "state", label: "State", visible: true, alwaysVisible: true },
  { id: "domainName", label: "Domain name", visible: true },
  { id: "users", label: "Users", visible: true, alwaysVisible: false },
  { id: "sessions", label: "Sessions", visible: false, alwaysVisible: false },
  { id: "idps", label: "IdPs", visible: false, alwaysVisible: false },
  { id: "healthy", label: "Healthy", visible: true, alwaysVisible: false },
  { id: "actions", label: "Actions", visible: true, alwaysVisible: true },
];  

export const currencyTypes = {
  "USD": "$",
  "EUR": "€",
};

export const clusterSizes = ["small", "medium", "large"]

export const securityAddOnsList = [
  {
    id: "web-application-firewall",
    name: "Web Application Firewall",
    description: "Keycloak-optimized WAF protection with smart rules for common attacks, malicious IPs, and rate limiting.",
    deploymentProperty: "useAlb",
    currency: "EUR",
    price: 100
  }
];

export const freeTrialPeriodDays = 30;